import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "planService",
    serviceName: "shared",
    query: gql`
      query planService($ids: [String]) {
        planService(ids: $ids) {
          data {
            title
            amount
            related_to
            validity_months
            lab_quantity
            unit_quantity
            doctor_quantity
            details
          }
        }
      }
    `,
  },
  update: {
    name: "updatePlanService",
    serviceName: "shared",
    query: gql`
      mutation updatePlanService($ids: [String]!, $details: String) {
        updatePlanService(ids: $ids, details: $details) {
          messages
          influenced_count
        }
      }
    `,
  },
};

export default schema;
